<template>
  <div class="row no-gutters station-queue-panel" :style="panelStyles" @click.prevent="panelClicked">
    <div class="col-10">
      <div class="row no-gutters">
        <div class="col-4 stock">{{panel.orderItem.stock.name}}</div>
        <div class="col-4 stock">{{panel.orderItem.glassHeight}} x {{panel.orderItem.glassWidth}}</div>
        <div class="col-4 stock">{{panelStationName}}</div>
      </div>
      <div class="row no-gutters">
        <div class="col-4"><i class="fal fa-scanner fa-fw mr-2"></i> {{panel.barcode}}</div>
        <div class="col-4">{{panel.order.sequenceNumber}}</div>
        <div class="col-4"><i class="fal fa-clock fa-fw mr-2"></i> {{panelStationDuration}}</div>
      </div>
    </div>
    <div class="col-2 station-queue-panel-options">
      <button class="btn btn-danger btn-block" @click.prevent="removePanelClicked" v-if="canRemovePanel">
        <i class="fal fa-times"></i> Remove
      </button>
    </div>
  </div>
</template>

<style scoped>
.station-queue-panel {
  padding: 6px;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  background-color: #333333;
  font-size: 1.2rem;
  color: #A0A0A0;
  cursor: pointer;
}
.station-queue-panel > div {
  line-height: 1.2rem;
  vertical-align: middle;
}
.station-queue-panel .stock {
  color: #4da9ff;
  font-weight: 600;
}
.station-queue-panel .station {
  font-weight: bold;
  color: #4fcc3b !important;
}
.station-queue-panel .row {
  padding: 3px;
}
.station-queue-panel-options {
  position: relative;
  font-size: 0.9rem;
}

</style>

<script>
import moment from 'moment'

export default {
  name: 'QueuePanelListItem',
  props: {
    panel: Object,
    stationHasSecondaryStation: Boolean,
    secondaryStationName: String,
    currentStationId: Number,
    removeEnabled: {
      type: Boolean,
      default: true
    },
    highlightColour: String
  },
  data() {
    return {
      panelTimeInQueue: 0
    }
  },
  mounted() {
    this.updatePanelTimer()
    this.$options.queuePanelTimer = setInterval(this.updatePanelTimer, 15000)
  },
  beforeDestroy () {
    clearInterval(this.$options.queuePanelTimer)
  },
  computed: {
    panelStyles() {
      if(this.highlightColour)
        return { 'border-left': `4px solid ${this.highlightColour}` }
      return {}
    },
    panelStationDuration() {
      if(!this.panel || !this.panel.currentStationStartDate)
        return ''

      if(this.panelTimeInQueue <= 60)
        return `${this.panelTimeInQueue} mins`      
      if(this.panelTimeInQueue >= 24*60)
        return '24+ hrs'

      let hours = Math.floor(this.panelTimeInQueue / 60)
      return `${hours} hrs`
    },
    panelStationName() {
      if(!this.panel || !this.panel.currentProductionStation)
        return ''

      return `At ${this.panel.currentProductionStation.name}`
    },
    canRemovePanel() {
      if(!this.panel)
        return false
        
      // Can only remove if the panel is at the station currently displaying it
      return this.removeEnabled && this.panel.currentProductionStationId == this.currentStationId
    },
    canDisplayPreview() {
      if(!this.panel)
        return false
        
      // Only display preview if we have order permission to access the SVG data in the order item
      return this.userHasReadPermission(this.PermissionTypes.OrderPermissionTypes.order)
    }
  },
  methods: {
    updatePanelTimer() {
      if(this.panel.currentStationStartDate == null)
        this.panelTimeInQueue = 0
      else
        this.panelTimeInQueue = Math.floor(moment.duration(moment().diff(this.panel.currentStationStartDate)).asMinutes())
    },
    panelClicked(ev) {
      this.$emit('panelClicked', ev)
    },
    previewClicked(evt) {
      this.$emit('previewClicked', evt)
    },
    removePanelClicked(ev) {
      ev.stopPropagation()
      ev.preventDefault()
      this.$emit('removePanel')
    }
  }
}
</script>